import { lazy } from 'react'

export const StayOnTrackV1 = lazy(() => import('./v1/StayOnTrackV1'))
